import React, { Component } from 'react';
import Navbar from '../../Navbar/Navbar';
import './gram.css'

class Samas extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="gramTop">
                <Navbar />
                <div className="foo">
                    <h1 className="paragraph">समास</h1>
                              समास शब्द की व्युत्पत्ति – सम् उपसर्गपूर्वक अस् धातु से घञ् प्रत्यय करने पर ‘समास’ शब्द निष्पन्न होता है। इसका अर्थ ‘संक्षिप्तीकरण’ है।

                <br /><br />समास की परिभाषा – संक्षेप करना अथवा अनेक पदों का एक पद हो जाना समास कहलाता है। अर्थात् जब अनेक पद मिलकर एक पद हो जाते हैं तो उसे समास कहा जाता है। जैसे–सीतायाः पतिः = सीतापतिः।
यहाँ ‘सीतायाः’ और ‘पतिः’ ये दो पद मिलकर एक पद (सीतापतिः) हो गया है, इसलिए यही समास है।

                <br /><br />समास होने पर अर्थ में कोई भी परिवर्तन नहीं होता है। जो अर्थ ‘सीतायाः पतिः’ (सीता का पति) इस विग्रह युक्त वाक्य का है, वही अर्थ ‘सीतापतिः’ इस समस्त शब्द का है।

पूर्वोत्तर विभक्ति का लोप – सीतायाः पतिः = सीतापतिः। इस विग्रह में ‘सीतायाः’ पद में षष्ठी विभक्ति है, ‘पतिः’ पद में प्रथमा विभक्ति सुनाई देती है। समास करने पर इन दोनों विभक्तियों का लोप हो जाता है। उसके बाद ‘सीतापति’ इस समस्त शब्द से पुनः प्रथमा विभक्ति की जाती है, इसी प्रकार सभी जगह जानना चाहिए।

समासयुक्त शब्द समस्तपद कहा जाता है। जैसे–

सीतापतिः।
समस्त शब्द का अर्थ समझाने के लिए जिस वाक्य को कहा जाता है, वह . वाक्य विग्रह कहलाता है। जैसे– ‘सीतायाः पतिः’ यह वाक्य विग्रह है।
                <br /><br />

                    <h3 className="paragraph">समास के भेद-</h3>
                समास में प्रायः दो पद होते हैं – पूर्वपद और उत्तर। पद का अर्थ पदार्थ होता है। जिस पदार्थ की प्रधानता होती है, उसी के अनुरूप ही समास की संज्ञा भी होती है। जैसे कि प्रायः पूर्वपदार्थ प्रधान अव्ययीभाव होता है। प्रायः उत्तरपदार्थ प्रधान तत्पुरुष होता है। तत्पुरुष का भेद कर्मधारय होता है। कर्मधारय का भेद द्विगु होता है। प्रायः अन्य पदार्थ प्रधान बहुब्रीहि होता है। प्रायः उभयपदार्थप्रधान द्वन्द्व होता है। इस प्रकार समास के सामान्य रूप से छः भेद होते हैं।

                <br />
                    <br />
                    <ol>
                        <li><h3 className="paragraph"> अव्ययीभाव समासः</h3>
                जब विभक्ति आदि अर्थों में वर्तमान अव्यय पद का सुबन्त के साथ नित्य रूप से समास होता है, तब वह अव्ययीभाव समास होता है अथवा इसमें यह जानना चाहिए-

जैसे–

अव्ययपदम् – अव्ययस्यार्थः – विग्रहः – समस्तपदम्

अधि – सप्तमीविभक्त्यर्थे – हरौ इति – अधिहरि

                <br /><br />
                        </li>
                        <li><h3 className="paragraph"> तत्पुरुष समास:</h3>
                तत्पुरुष समास में प्रायः उत्तर पदार्थ की प्रधानता होती है। जैसे– राज्ञः पुरुषः – राजपुरुषः (राजा का पुरुष)। यहाँ उत्तर पद ‘पुरुषः’ है, उसी की प्रधानता है। ‘राजपुरुषम् आनय’ (राजा के पुरुष को लाओ) ऐसा कहने पर पुरुष को ही लाया। जाता है। राजा को नहीं। तत्पुरुष समास में पूर्व पद में जो विभक्ति होती है, प्रायः उसी के नाम से ही समास का भी नाम होता है। जैसे–

कृष्णं श्रितः – कृष्णश्रितः (द्वितीयातत्पुरुषः)

                <br /><br />
                        </li>
                        <li><h3 className="paragraph"> कर्मधारय समास:</h3>
                जब तत्पुरुष समास के दोनों पदों में एक ही विभक्ति अर्थात् समान विभक्ति होती है, तब वह समानाधिकरण तत्पुरुष समास कहा जाता है। इसी समास को कर्मधारय नाम से जाना जाता है। इस समास में साधारणतया पूर्वपद विशेषण और उत्तरपद विशेष्य होता है। जैसे– नीलम् कमलम् = नीलकमलम्।।

                <br /><br />
                        </li>
                        <li><h3 className="paragraph"> बहुव्रीहिसमासः</h3>
                जिस समास में जब अन्य पदार्थ की प्रधानता होती है तब वह बहुव्रीहि समास कहा जाता है। अर्थात् इस समास में न तो पूर्व पदार्थ की प्रधानता होती है और न ही उत्तर पदार्थ की, अपितु दोनों पदार्थ मिलकर अन्य पदार्थ का बोध कराते हैं। समस्त पद का प्रयोग अन्य पदार्थ के विशेषण के रूप में होता है। जैसे–
                <ul>
                                <li>पीतम् अम्बरं यस्य सः = पीताम्बरः (विष्णु)।</li>
                                <li>पीला है वस्त्र जिसका वह = पीताम्बर, अर्थात् विष्णु।</li>


                            </ul>
                            <br /><br />
                        </li>
                        <li><h3 className="paragraph"> द्विगुसमासः</h3>
                            <ul>
                                <li>‘संख्यापूर्वो द्विगु’ इस पाणिनीय सूत्र के अनुसार जब कर्मधारय समास का पूर्वपद संख्यावाची तथा उत्तरपद संज्ञावाचक होता है, तब वह ‘द्विगु समास’ कहलाता</li>
                                <li>यह समास प्रायः समूह अर्थ में होता है।</li>
                                <li>समस्त पद सामान्य रूप से नपुंसकलिङ्ग के एकवचन में अथवा स्त्रीलिङ्ग के एकवचन में होता है।</li>
                                <li>इसके विग्रह में षष्ठी विभक्ति का प्रयोग किया जाता है।</li>

                            </ul>

                            <br /><br />
                        </li>
                        <li><h3 className="paragraph">द्वन्द्वसमास:</h3>
                द्वन्द्व समास में आकांक्षायुक्त दो पदों के मध्य में ‘च’ (और, अथवा) आता है, है। जैसे– धर्मः च अर्थ : च – धर्मार्थो। यहाँ पूर्व पद ‘धर्मः’ और उत्तर पद ‘अर्थः’ इन दोनों की ही प्रधानता है। द्वन्द्व समास में समस्त पद प्रायः द्विवचन में होता है। यथा–

हरिश्च हरश्च – हरिहरौ।

                <br /><br />
                        </li>
                    </ol>
                </div>
            </div>
        )
    }
}

export default Samas;